/* eslint-disable i18next/no-literal-string -- css not user facing*/
import { defineSlotRecipe } from '@chakra-ui/react';

export const menu = defineSlotRecipe({
  className: 'chakra-menu',
  slots: ['content', 'indicator', 'item', 'itemCommand', 'itemGroupLabel', 'itemText', 'separator'],
  base: {
    content: {
      borderRadius: 'md',
      border: '1px solid',
      borderColor: 'blue.50',
      boxShadow: 'none',
      padding: 2,
      fontSize: 'md',
    },
    item: {
      borderRadius: 'md',
      fontSize: 'md',
      // Gap between items
      // Not using CSS gap as with react-select the container may not be the list directly
      marginBottom: 0.5,
      _last: {
        marginBottom: 0,
      },
      _hover: {
        background: 'blue.50',
      },
    },
    itemText: {
      fontSize: 'md',
    },
  },

  variants: {
    size: {
      md: {
        content: {
          minW: '14rem',
          padding: 2,
        },
        item: {
          textStyle: 'md',
          paddingX: 3,
          padinngY: 1.5,
          marginBottom: 0,
        },
      },
    },
  },
});
